<!-- Form Container -->
<div
  data-testid="add-form-container"
  class="flex flex-col"
  [class.overflow-x-hidden]="enableOverflow"
  [style.height]="height"
>
  <!-- Header with action buttons -->
  <div class="sticky-header flex justify-between items-center">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ title | translate }}
    </h2>
    <div class="flex gap-3">
      @for (action of computedHeaderActions(); track action.action) {
        <app-button
          [testId]="'header-action-' + action.action"
          [label]="action.label"
          [icon]="action.icon"
          (emitOnClick)="onHeaderAction(action.action)"
          [outlined]="action.outlined || false"
          [type]="action.severity || 'primary'"
          [disabled]="action.disabled || false"
          [loading]="action.loading || false"
        ></app-button>
      }
    </div>
  </div>

  <!-- Scrollable content area -->
  <div class="flex-1 min-h-0 px-6" [class.overflow-auto]="enableOverflow">
    <form [formGroup]="form" class="p-2" data-testid="add-form-form">
      <ng-template #tableSectionBlock let-tableSection>
        @if (tableSection.show) {
          <section
            class="form-section form-product"
            [attr.data-section]="tableSection.name || 'table-section'"
          >
            <!-- Title + Thêm button on same row (giống "Tạo Kho hàng" sau "Kho hàng") -->
            <div class="flex items-center">
              <h2 class="section-title text-sm mr-4">
                {{ tableSection.title | translate }}
              </h2>
              @if (
                (tableSection.addDropdownPlaceholder != null ||
                  tableSection.addDropdownOptions != null ||
                  tableSection.onAddDropdownSelect != null) &&
                !viewMode
              ) {
                <div class="flex gap-2">
                  <app-button
                    [testId]="getTableSectionTestId(tableSection, 'add-dropdown-btn')"
                    [label]="
                      tableSection.addDropdownPlaceholder ||
                        'common.actions.add' | translate
                    "
                    icon="add"
                    type="info"
                    [outlined]="false"
                    [disabled]="!tableSection.addDropdownOptions?.length"
                    (emitOnClick)="openAddFieldMenu(tableSection, $event)"
                  ></app-button>
                </div>
              }
            </div>

            <!-- Error Message -->
            @if (tableSection.errorMessage) {
              <div class="validation-error text-sm px-2 pt-2">
                {{ tableSection.errorMessage | translate }}
              </div>
            }

            <!-- Search Form (if configured) -->
            @if (
              tableSection.searchFormConfig &&
              tableSection.searchFormConfig.length > 0
            ) {
              <div class="px-2 pt-2">
                <app-search-form
                  [attr.data-testid]="
                    getTableSectionTestId(tableSection, 'search-form')
                  "
                  [searchFormat]="tableSection.searchFormConfig"
                  (formSearch)="tableSection.onSearch?.($event)"
                  (formReset)="tableSection.onReset?.()"
                >
                  <div slot="actions" class="flex gap-2">
                    @if (
                      tableSection.useAdvancedTable &&
                      tableSection.flexibleColumns &&
                      tableSection.flexibleColumns.length > 0
                    ) {
                      <app-button
                        [testId]="getTableSectionTestId(tableSection, 'column-config-btn')"
                        type="success"
                        [outlined]="true"
                        icon="view_column"
                        (emitOnClick)="
                          handleColumnConfigClick(tableSection, $event)
                        "
                      ></app-button>
                    }
                    @if (
                      tableSection.primaryButton &&
                      tableSection.primaryButton.show !== false
                    ) {
                      <app-status-filter
                        [attr.data-testid]="
                          getTableSectionTestId(tableSection, 'status-filter')
                        "
                        [primaryButton]="tableSection.primaryButton"
                        (primaryButtonClick)="
                          handleprimaryButtonClick(tableSection)
                        "
                      ></app-status-filter>
                    }
                  </div>
                </app-search-form>
              </div>
            }

            <!-- Primary button when no search form (e.g. product field mapping) -->
            @if (
              tableSection.primaryButton &&
              tableSection.primaryButton.show !== false &&
              (!tableSection.searchFormConfig ||
                tableSection.searchFormConfig.length === 0) &&
              !viewMode
            ) {
              <div class="flex gap-2 px-2 pt-2">
                <app-status-filter
                  [attr.data-testid]="
                    getTableSectionTestId(tableSection, 'status-filter')
                  "
                  [primaryButton]="tableSection.primaryButton"
                  (primaryButtonClick)="handleprimaryButtonClick(tableSection)"
                ></app-status-filter>
              </div>
            }

            <!-- Table Actions -->
            @if (
              tableSection.actions &&
              tableSection.actions.length > 0 &&
              !viewMode
            ) {
              <div class="flex gap-2 px-2 pt-2">
                @for (action of tableSection.actions; track action.action) {
                  <app-button
                    [testId]="
                      getTableSectionTestId(
                        tableSection,
                        'action-' + action.action
                      )
                    "
                    [label]="action.label"
                    [icon]="action.icon"
                    (emitOnClick)="
                      onTableAction(
                        tableSection.title,
                        action.action,
                        action.action === 'deleteSelected'
                          ? tableSection.selection
                          : undefined
                      )
                    "
                    [disabled]="action.disabled || false"
                    [type]="action.severity || 'secondary'"
                    [outlined]="action.outlined || false"
                  ></app-button>
                }
              </div>
            }

            <!-- Data Table -->
            <div class="px-2 pt-4">
              <ng-template #actionsTemplate let-rowData>
                @if (tableSection.name === "product_list") {
                  <div class="flex gap-2 justify-center">
                    <button
                      [attr.data-testid]="
                        getTableRowActionTestId(tableSection, rowData, 'edit')
                      "
                      type="button"
                      (click)="
                        onTableAction(tableSection.title, 'edit', rowData)
                      "
                      class="action-link action-edit cursor-pointer"
                    >
                      {{ "common.actions.edit" | translate }}
                    </button>
                    @if (rowData.status === "DRAFT") {
                      <button
                        [attr.data-testid]="
                          getTableRowActionTestId(
                            tableSection,
                            rowData,
                            'activate'
                          )
                        "
                        type="button"
                        (click)="
                          onTableAction(tableSection.title, 'activate', rowData)
                        "
                        class="action-link action-enable cursor-pointer"
                      >
                        {{
                          "onlineStore.form.product_list.actions.activate"
                            | translate
                        }}
                      </button>
                    }
                    <button
                      [attr.data-testid]="
                        getTableRowActionTestId(tableSection, rowData, 'view')
                      "
                      type="button"
                      (click)="
                        onTableAction(tableSection.title, 'view', rowData)
                      "
                      class="action-link action-view cursor-pointer"
                    >
                      {{ "common.actions.view" | translate }}
                    </button>
                    @if (rowData.status === "ACTIVE") {
                      <button
                        [attr.data-testid]="
                          getTableRowActionTestId(
                            tableSection,
                            rowData,
                            'deactivate-delete'
                          )
                        "
                        type="button"
                        (click)="
                          onTableAction(tableSection.title, 'delete', rowData)
                        "
                        class="action-link action-delete cursor-pointer"
                      >
                        {{
                          "onlineStore.form.product_list.actions.deactivate_and_delete"
                            | translate
                        }}
                      </button>
                    }
                    @if (
                      rowData.status === "DRAFT" ||
                      rowData.status === "INACTIVE"
                    ) {
                      <button
                        [attr.data-testid]="
                          getTableRowActionTestId(
                            tableSection,
                            rowData,
                            'delete'
                          )
                        "
                        type="button"
                        (click)="
                          onTableAction(tableSection.title, 'delete', rowData)
                        "
                        class="action-link action-delete cursor-pointer"
                      >
                        {{ "common.actions.delete" | translate }}
                      </button>
                    }
                  </div>
                } @else if (
                  tableSection.name === "product_field_mapping" &&
                  tableSection.allowRowActions !== false
                ) {
                  <div class="flex gap-2 justify-center">
                    @if (!rowData.isRequired) {
                      <button
                        [attr.data-testid]="
                          getTableRowActionTestId(
                            tableSection,
                            rowData,
                            'delete'
                          )
                        "
                        type="button"
                        (click)="
                          onTableAction(tableSection.title, 'delete', rowData)
                        "
                        class="action-link action-delete cursor-pointer"
                      >
                        {{ "common.actions.delete" | translate }}
                      </button>
                    }
                  </div>
                } @else if (tableSection.name === "offer_scope_lines") {
                  <div class="flex gap-2 justify-center">
                    <button
                      [attr.data-testid]="
                        getTableRowActionTestId(tableSection, rowData, 'delete')
                      "
                      type="button"
                      (click)="
                        onTableAction(tableSection.title, 'delete', rowData)
                      "
                      class="action-link action-delete cursor-pointer"
                    >
                      {{ "common.actions.delete" | translate }}
                    </button>
                  </div>
                }
              </ng-template>
              @if (tableSection.useAdvancedTable) {
                <advanced-data-table
                  [attr.data-testid]="getTableSectionTestId(tableSection, 'table')"
                  [dataSource]="tableSection.data"
                  [defaultColumns]="
                    tableSection.defaultColumns || tableSection.columns
                  "
                  [flexibleColumns]="tableSection.flexibleColumns || []"
                  [rows]="tableSection.rows || 20"
                  [first]="tableSection.first || 0"
                  [totalRecords]="
                    tableSection.totalRecords || tableSection.data.length
                  "
                  [loading]="tableSection.loading || false"
                  [hasCheckColumn]="tableSection.hasCheckbox || false"
                  [hasSerialColumn]="tableSection.hasSerialColumn !== false"
                  [selection]="tableSection.selection || []"
                  [actionsTemplate]="actionsTemplate"
                  [scrollHeight]="scrollHeight"
                  [showInternalColumnConfigButton]="false"
                  (pageChange)="tableSection.onPageChange?.($event)"
                  (selectionChange)="
                    onTableSelectionChange(tableSection.title, $event)
                  "
                  class="text-sm"
                >
                  <!-- Custom templates for advanced table -->
                  <ng-template
                    #customTemplate
                    let-value
                    let-rowData="rowData"
                    let-column="column"
                  >
                    @if (tableSection.name === "product_list") {
                      @if (column && column.template === "currencyTemplate") {
                        <span class="text-xs text-gray-600 text-right">
                          {{ formatCurrency(value) }}
                        </span>
                      }
                    }
                  </ng-template>

                  <!-- Status Template -->
                  <ng-template #statusTemplate let-status>
                    @if (tableSection.name === "product_list") {
                      <div class="flex items-center justify-center gap-1">
                        <p-tag
                          [attr.data-testid]="
                            getTableSectionTestId(tableSection, 'status-tag')
                          "
                          [value]="getStatusDisplayText(status)"
                          [severity]="getStatusSeverity(status)"
                          styleClass="status-tag"
                          [ngStyle]="getStatusStyle(status)"
                          [pTooltip]="getStatusDisplayText(status)"
                          tooltipPosition="top"
                          tooltipStyleClass="custom-tooltip"
                          [showDelay]="300"
                          [hideDelay]="0"
                        />
                      </div>
                    }
                  </ng-template>
                </advanced-data-table>
              } @else {
                <app-data-table
                  [attr.data-testid]="getTableSectionTestId(tableSection, 'table')"
                  [dataSource]="tableSection.data"
                  [columns]="tableSection.columns"
                  [rows]="tableSection.rows ?? 20"
                  [first]="tableSection.first ?? 0"
                  [totalRecords]="
                    tableSection.totalRecords ?? tableSection.data.length
                  "
                  [showPaginator]="tableSection.showPaginator !== false"
                  [loading]="tableSection.loading || false"
                  [hasCheckColumn]="tableSection.hasCheckbox || false"
                  [hasSerialColumn]="tableSection.hasSerialColumn !== false"
                  [selection]="tableSection.selection || []"
                  [actionsTemplate]="actionsTemplate"
                  [scrollHeight]="scrollHeight"
                  [getFieldError]="getFieldError"
                  (selectionChange)="
                    onTableSelectionChange(tableSection.title, $event)
                  "
                  (cellValueChange)="
                    onTableCellValueChange(tableSection.title, $event)
                  "
                  (cellInputChange)="
                    onTableCellInputChange(tableSection.title, $event)
                  "
                  (pageChange)="tableSection.onPageChange?.($event)"
                  class="text-sm"
                >
                  <!-- Pass custom templates to data table -->
                  <ng-template #customTemplate let-rowData let-column="column">
                    @if (
                      column?.prop === "propertyAsset" &&
                      rowData &&
                      isArray(rowData) &&
                      rowData.length > 0
                    ) {
                      <div class="flex flex-col gap-1">
                        @for (asset of rowData; track asset.asset) {
                          <div class="flex items-center gap-2">
                            @if (asset.image) {
                              <img
                                [src]="asset.image"
                                [alt]="asset.originalName"
                                class="w-6 h-6 object-cover rounded"
                                (error)="onImageError($event)"
                              />
                            }
                            <span
                              class="text-xs text-gray-600 truncate"
                              [title]="asset.originalName"
                            >
                              {{ asset.originalName }}
                            </span>
                          </div>
                        }
                      </div>
                    } @else if (column?.prop === "propertyAsset") {
                      <span class="text-gray-400 text-xs"></span>
                    } @else if (
                      column?.prop === "generateSku" ||
                      column?.prop === "giftFlag"
                    ) {
                      <span class="text-xs justify-center items-center flex">
                        {{
                          rowData
                            ? ("common.options.yes" | translate)
                            : ("common.options.no" | translate)
                        }}
                      </span>
                    } @else if (column?.template === "currencyTemplate") {
                      <span
                        class="text-xs text-gray-600 flex items-center justify-end"
                      >
                        {{ formatCurrency(rowData) }}
                      </span>
                    } @else {
                      <span class="text-xs">{{ rowData }}</span>
                    }
                  </ng-template>
                </app-data-table>
              }
            </div>
          </section>
        }
      </ng-template>

      <!-- Dynamic Form Sections -->
      @for (section of sections(); track section; let sectionIndex = $index) {
        <section
          class="form-section"
          [attr.data-testid]="'form-section-' + sectionIndex"
        >
          <div class="flex items-center">
            <h2 class="section-title text-sm mr-4">
              {{ section | translate }}
            </h2>
            @if (getSectionButtons(section).length > 0) {
              <div class="flex gap-2">
                @for (
                  button of getSectionButtons(section);
                  track button.action
                ) {
                  <app-button
                    [testId]="getSectionButtonTestId(section, button.action)"
                    [label]="button.label"
                    [icon]="button.icon"
                    [type]="button.severity || 'primary'"
                    [outlined]="button.outlined || false"
                    [disabled]="button.disabled || false"
                    (emitOnClick)="
                      onSectionAction(section, button.action, $event)
                    "
                  ></app-button>
                }
              </div>
            }
          </div>

          <div
            [class]="'grid gap-2 px-4 py-2 ' + getSectionGridColsClass(section)"
          >
            @for (
              field of getFieldsBySection(section);
              track field.controlName
            ) {
              @if (!field.hidden) {
                <div
                  [class]="'form-field field-' + field.controlName"
                  [class.col-span-2]="field.colspan === 2"
                  [class.col-span-4]="field.colspan === 4"
                  [class.label-inline]="field.labelInline"
                  [style.width]="
                    field.width ? 'calc(' + field.width + ' - 9px)' : null
                  "
                >
                  <div
                    class="form-label text-sm"
                    [class.tax-number-label]="field.controlName === 'taxNumber'"
                  >
                    <span class="label-text-wrapper inline-flex items-center">
                      @if (field.translateLabel !== false) {
                        {{ getFieldLabel(field) | translate }}
                      } @else {
                        {{ getFieldLabel(field) }}
                      }
                      @if (field.required) {
                        <span class="text-red-500">*</span>
                      }
                      @if (field.hint && field.hintAsTooltip) {
                        <span
                          class="material-symbols-outlined ml-1 text-gray-400 hover:text-blue-500 cursor-help text-xs"
                          [pTooltip]="getFieldHint(field)"
                          tooltipPosition="top"
                          >info</span
                        >
                      }
                    </span>
                  </div>

                  @switch (field.type) {
                    @case ("text") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          {{ form.get(field.controlName)?.value || "-" }}
                        </div>
                      } @else if (field.showVideoPlatformHint) {
                        <div class="relative w-full">
                          <input
                            pInputText
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.value]="form.get(field.controlName)?.value ?? null"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            [readonly]="field.readonly || viewMode"
                            [attr.required]="field.required ? '' : null"
                            class="w-full text-sm pr-8"
                            [ngStyle]="getCustomStyles(field)"
                            (input)="
                              onTextInputChange(field.controlName, $event)
                            "
                            (compositionstart)="
                              onCompositionStart(field.controlName)
                            "
                            (compositionend)="
                              onCompositionEnd(field.controlName, $event)
                            "
                            (blur)="onTextBlur(field.controlName, $event)"
                          />
                          @if (getVideoPlatformIconClass(field); as icon) {
                            <i
                              [class]="
                                'pi ' +
                                icon +
                                ' absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-sm'
                              "
                            ></i>
                          }
                        </div>
                      } @else {
                        <input
                          pInputText
                          [formControlName]="field.controlName"
                          [attr.data-testid]="'form-field-' + field.controlName"
                          [attr.value]="form.get(field.controlName)?.value ?? null"
                          [placeholder]="
                            !viewMode && !isFieldDisabled(field)
                              ? getFieldPlaceholder(field)
                              : ''
                          "
                          [readonly]="field.readonly || viewMode"
                          [attr.required]="field.required ? '' : null"
                          class="w-full text-sm"
                          [ngStyle]="getCustomStyles(field)"
                          (input)="onTextInputChange(field.controlName, $event)"
                          (compositionstart)="
                            onCompositionStart(field.controlName)
                          "
                          (compositionend)="
                            onCompositionEnd(field.controlName, $event)
                          "
                          (blur)="onTextBlur(field.controlName, $event)"
                        />
                      }
                    }
                    @case ("password") {
                      <div class="flex w-full gap-2 items-center">
                        <div class="relative flex-1 min-w-0">
                          <input
                            pInputText
                            [type]="getPasswordInputType(field.controlName)"
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.value]="form.get(field.controlName)?.value ?? null"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            [readonly]="field.readonly || viewMode"
                            [attr.required]="field.required ? '' : null"
                            [disabled]="isPasswordInputDisabled(field)"
                            class="w-full text-sm pr-10"
                            [ngStyle]="getCustomStyles(field)"
                            (input)="
                              onTextInputChange(field.controlName, $event)
                            "
                          />
                          @if (isPasswordToggleVisible(field)) {
                            <button
                              [attr.data-testid]="
                                getFieldActionTestId(field, 'toggle-password')
                              "
                              type="button"
                              class="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-gray-500 hover:text-gray-700 focus:outline-none"
                              [attr.aria-label]="
                                (passwordVisible()[field.controlName]
                                  ? 'common.actions.hide'
                                  : 'common.actions.show'
                                ) | translate
                              "
                              (click)="togglePasswordVisible(field.controlName)"
                            >
                              @if (passwordVisible()[field.controlName]) {
                                <i class="pi pi-eye-slash text-sm"></i>
                              } @else {
                                <i class="pi pi-eye text-sm"></i>
                              }
                            </button>
                          }
                        </div>
                        @if (field.showCopyButton) {
                          <app-button
                            [testId]="getFieldActionTestId(field, 'copy')"
                            class="shrink-0"
                            type="secondary"
                            [outlined]="true"
                            icon="content_copy"
                            label=""
                            (emitOnClick)="copyPasswordFieldValue(field)"
                          ></app-button>
                        }
                      </div>
                    }
                    @case ("number") {
                      @if (field.suffix) {
                        <div class="relative w-full">
                          <div
                            class="unit-field-wrapper w-full"
                            (focusin)="onUnitFieldFocus(field)"
                            (focusout)="onUnitFieldBlur(field)"
                          >
                            <p-inputNumber
                              [formControlName]="field.controlName"
                              [inputId]="field.controlName"
                              [attr.data-testid]="'form-field-' + field.controlName"
                              [placeholder]="
                                !viewMode && !isFieldDisabled(field)
                                  ? getFieldPlaceholder(field)
                                  : ''
                              "
                              [min]="field.min || 0"
                              [class]="
                                'w-full text-sm currency-amount ' +
                                (shouldShowErrorStyling(field.controlName)
                                  ? 'show-error-styling'
                                  : '')
                              "
                              [attr.max]="field.max"
                              [useGrouping]="field.useGrouping !== false"
                              [mode]="field.decimal ? 'decimal' : undefined"
                              [minFractionDigits]="
                                field.decimal ? 0 : undefined
                              "
                              [maxFractionDigits]="
                                field.decimal ? (field.maxFractionDigits ?? 5) : undefined
                              "
                              [suffix]="field.suffix"
                              [ngStyle]="getCustomStyles(field)"
                            ></p-inputNumber>
                          </div>
                          @if (shouldShowError(field.controlName)) {
                            <span
                              class="validation-icon absolute right-2 top-1/2 -translate-y-1/2 text-red-500 cursor-pointer"
                              [pTooltip]="getErrorMessage(field) | translate"
                              tooltipPosition="top"
                              tooltipStyleClass="custom-tooltip"
                              [showDelay]="150"
                              [hideDelay]="0"
                            >
                              i
                            </span>
                          }
                        </div>
                      } @else {
                        @if (viewMode && textOnlyMode) {
                          <div
                            class="w-full text-sm py-2"
                            [ngStyle]="getCustomStyles(field)"
                          >
                            @if (form.get(field.controlName)?.value != null) {
                              {{
                                form.get(field.controlName)?.value
                                  | number: "1.0-0"
                              }}
                            } @else {
                              -
                            }
                          </div>
                        } @else {
                          <div class="relative w-full">
                            <p-inputNumber
                              [formControlName]="field.controlName"
                              [inputId]="field.controlName"
                              [attr.data-testid]="'form-field-' + field.controlName"
                              [placeholder]="
                                !viewMode && !isFieldDisabled(field)
                                  ? getFieldPlaceholder(field)
                                  : ''
                              "
                              [min]="field.min || 0"
                              [attr.required]="field.required ? '' : null"
                              [class]="
                                'w-full text-sm ' +
                                (shouldShowErrorStyling(field.controlName)
                                  ? 'show-error-styling'
                                  : '')
                              "
                              [attr.max]="field.max"
                              [useGrouping]="field.useGrouping !== false"
                              [mode]="field.decimal ? 'decimal' : undefined"
                              [minFractionDigits]="
                                field.decimal ? 0 : undefined
                              "
                              [maxFractionDigits]="
                                field.decimal ? (field.maxFractionDigits ?? 5) : undefined
                              "
                              [ngStyle]="getCustomStyles(field)"
                            ></p-inputNumber>
                            @if (shouldShowError(field.controlName)) {
                              <span
                                class="validation-icon absolute right-2 top-1/2 -translate-y-1/2 text-red-500 cursor-pointer"
                                [pTooltip]="getErrorMessage(field) | translate"
                                tooltipPosition="top"
                                tooltipStyleClass="custom-tooltip"
                                [showDelay]="150"
                                [hideDelay]="0"
                              >
                                i
                              </span>
                            }
                          </div>
                        }
                      }
                    }
                    @case ("currency") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          @if (form.get(field.controlName)?.value != null) {
                            {{
                              form.get(field.controlName)?.value
                                | number: "1.0-0"
                            }}
                            ₫
                          } @else {
                            -
                          }
                        </div>
                      } @else {
                        <div
                          class="unit-field-wrapper w-full"
                          (focusin)="onUnitFieldFocus(field)"
                          (focusout)="onUnitFieldBlur(field)"
                        >
                          <p-inputNumber
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            [min]="field.min || 0"
                            [attr.required]="field.required ? '' : null"
                            [class]="
                              'w-full text-sm currency-amount ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            [attr.max]="field.max"
                            [useGrouping]="true"
                            [currency]="'VND'"
                            [locale]="'vi-VN'"
                            [suffix]="' ₫'"
                            [ngStyle]="getCustomStyles(field)"
                          ></p-inputNumber>
                        </div>
                      }
                    }
                    @case ("date") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          {{ form.get(field.controlName)?.value || "-" }}
                        </div>
                      } @else {
                        @if (field.multiple) {
                          <p-datepicker
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.required]="field.required ? '' : null"
                            [selectionMode]="'multiple'"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            [minDate]="getMinDate(field)"
                            [maxDate]="field.maxDate"
                            [disabled]="isFieldDisabled(field) || viewMode"
                            [readonlyInput]="true"
                            [showIcon]="true"
                            [inputStyleClass]="
                              'w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg text-sm transition-colors'
                            "
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            [ngStyle]="getCustomStyles(field)"
                          ></p-datepicker>
                        } @else {
                          <app-advanced-datepicker
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [formControlName]="field.controlName"
                            mode="single"
                            [showTime]="field.showTime || field.timeOnly || false"
                            [timeOnly]="field.timeOnly || false"
                            [showSeconds]="field.showSeconds || false"
                            [timeFormat]="
                              field.hourFormat === '12' ? '12h' : '24h'
                            "
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            [minDate]="getMinDate(field)"
                            [maxDate]="field.maxDate"
                            [disabled]="isFieldDisabled(field) || viewMode"
                            [dateFormat]="'DD/MM/YYYY'"
                            [required]="field.required || false"
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            [ngStyle]="getCustomStyles(field)"
                            (dateChange)="
                              onDateSelect(field.controlName, $event)
                            "
                          ></app-advanced-datepicker>
                        }
                      }
                    }
                    @case ("dateRange") {
                      <app-advanced-datepicker
                        [attr.data-testid]="'form-field-' + field.controlName"
                        [formControlName]="field.controlName"
                        mode="range"
                        [showTime]="field.showTime || false"
                        [showSeconds]="field.showSeconds || false"
                        [required]="field.required || false"
                        [timeFormat]="field.hourFormat === '12' ? '12h' : '24h'"
                        [placeholder]="
                          !viewMode && !isFieldDisabled(field)
                            ? getFieldPlaceholder(field)
                            : ''
                        "
                        [minDate]="getMinDate(field)"
                        [maxDate]="field.maxDate"
                        [disabled]="isFieldDisabled(field) || viewMode"
                        [dateFormat]="'DD/MM/YYYY'"
                        [class]="
                          'w-full text-sm ' +
                          (shouldShowErrorStyling(field.controlName)
                            ? 'show-error-styling'
                            : '')
                        "
                        [ngStyle]="getCustomStyles(field)"
                        (dateChange)="
                          onDateRangeSelect(field.controlName, $event)
                        "
                      ></app-advanced-datepicker>
                    }
                    @case ("dropdown") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          @if (field.multiple) {
                            {{ getMultipleDropdownDisplayValue(field) || "-" }}
                          } @else {
                            {{ getDropdownDisplayValue(field) || "-" }}
                          }
                        </div>
                      } @else {
                        @if (field.multiple) {
                          <p-multiselect
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.required]="field.required ? '' : null"
                            [options]="getFieldOptions(field)"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            optionLabel="label"
                            optionValue="value"
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            (onChange)="
                              onDropdownChange(field.controlName, $event)
                            "
                            [showClear]="getShowClearForField(field)"
                            [ngStyle]="getCustomStyles(field)"
                          ></p-multiselect>
                        } @else {
                          <p-select
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.required]="field.required ? '' : null"
                            [options]="getFieldOptions(field)"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            optionLabel="label"
                            optionValue="value"
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '') +
                              (isFieldDisabled(field)
                                ? ' dropdown-disabled'
                                : '')
                            "
                            (onChange)="
                              onDropdownChange(field.controlName, $event)
                            "
                            [showClear]="getShowClearForField(field)"
                            [ngStyle]="getCustomStyles(field)"
                          ></p-select>
                        }
                      }
                    }
                    @case ("searchableDropdown") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          @if (field.multiple) {
                            {{ getMultipleDropdownDisplayValue(field) || "-" }}
                          } @else {
                            {{ getDropdownDisplayValue(field) || "-" }}
                          }
                        </div>
                      } @else {
                        @if (field.multiple) {
                          @let paginatedField = enrichPaginatedField(field);
                          <p-multiselect
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.required]="field.required ? '' : null"
                            [options]="getFieldOptions(field)"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            optionLabel="label"
                            optionValue="value"
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            (onChange)="
                              onDropdownChange(field.controlName, $event)
                            "
                            (onClose)="onMultiselectClose(field.controlName)"
                            (onFilter)="paginatedField.onFilter?.($event.filter)"
                            (onLazyLoad)="paginatedField.onLazyLoad?.($event)"
                            [showClear]="getShowClearForField(field)"
                            [filter]="paginatedField.paginatedOptions ? true : true"
                            [filterBy]="paginatedField.filterBy || 'label'"
                            [loading]="paginatedField.loading"
                            [lazy]="!!paginatedField.onLazyLoad"
                            [virtualScroll]="paginatedField.virtualScroll ?? false"
                            [virtualScrollItemSize]="paginatedField.virtualScrollItemSize"
                            optionDisabled="disabled"
                            [ngStyle]="getCustomStyles(field)"
                          >
                            <ng-template let-option pTemplate="item">
                              @if (option?.loading) {
                                <div class="dropdown-loading-more-option">
                                  <span
                                    class="dropdown-loading-more-spinner"
                                    aria-hidden="true"
                                  ></span>
                                </div>
                              } @else {
                                <span>{{ option?.label }}</span>
                              }
                            </ng-template>
                          </p-multiselect>
                        } @else {
                          @let paginatedField = enrichPaginatedField(field);
                          <p-select
                            [formControlName]="field.controlName"
                            [attr.data-testid]="'form-field-' + field.controlName"
                            [attr.required]="field.required ? '' : null"
                            [options]="getFieldOptions(field)"
                            [placeholder]="
                              !viewMode && !isFieldDisabled(field)
                                ? getFieldPlaceholder(field)
                                : ''
                            "
                            optionLabel="label"
                            optionValue="value"
                            [class]="
                              'w-full text-sm ' +
                              (shouldShowErrorStyling(field.controlName)
                                ? 'show-error-styling'
                                : '')
                            "
                            (onChange)="
                              onDropdownChange(field.controlName, $event)
                            "
                            (onFilter)="paginatedField.onFilter?.($event.filter)"
                            (onLazyLoad)="paginatedField.onLazyLoad?.($event)"
                            [showClear]="getShowClearForField(field)"
                            [filter]="paginatedField.filter ?? true"
                            [filterBy]="paginatedField.filterBy || 'label'"
                            [loading]="paginatedField.loading"
                            [lazy]="!!paginatedField.onLazyLoad"
                            [virtualScroll]="paginatedField.virtualScroll ?? false"
                            [virtualScrollItemSize]="
                              paginatedField.virtualScrollItemSize
                            "
                            optionDisabled="disabled"
                            [filterPlaceholder]="
                              paginatedField.filterPlaceholder
                                ? (paginatedField.filterPlaceholder | translate)
                                : ('common.search.form.actions.search'
                                  | translate)
                            "
                            [ngStyle]="getCustomStyles(field)"
                            [appendTo]="'body'"
                          >
                            <ng-template let-option pTemplate="item">
                              @if (option?.loading) {
                                <div class="dropdown-loading-more-option">
                                  <span
                                    class="dropdown-loading-more-spinner"
                                    aria-hidden="true"
                                  ></span>
                                </div>
                              } @else {
                                <span>{{ option?.label }}</span>
                              }
                            </ng-template>
                            @if (
                              field.onLoadMore &&
                              field.hasMore &&
                              !field.autoLoadMore
                            ) {
                              <ng-template pTemplate="footer">
                                <div class="dropdown-load-more-footer">
                                  <p-button
                                    [attr.data-testid]="
                                      getFieldActionTestId(field, 'load-more')
                                    "
                                    size="small"
                                    severity="secondary"
                                    text
                                    [label]="
                                      (field.loadMoreLabel || 'common.show_more')
                                        | translate
                                    "
                                    [loading]="field.loadingMore"
                                    [disabled]="field.loadingMore"
                                    (onClick)="field.onLoadMore()"
                                  ></p-button>
                                </div>
                              </ng-template>
                            }
                          </p-select>
                        }
                      }
                    }
                    @case ("warehouseAutocomplete") {
                      <p-autocomplete
                        [formControlName]="field.controlName"
                        [attr.required]="field.required ? '' : null"
                        [suggestions]="
                          warehouseSuggestions[field.controlName] || []
                        "
                        (completeMethod)="onWarehouseSearch($event, field)"
                        [minLength]="3"
                        [showClear]="true"
                        [dropdown]="false"
                        [forceSelection]="false"
                        [placeholder]="
                          !viewMode && !isFieldDisabled(field)
                            ? getFieldPlaceholder(field)
                            : ''
                        "
                        [class]="
                          'w-full text-sm ' +
                          (shouldShowErrorStyling(field.controlName)
                            ? 'show-error-styling'
                            : '')
                        "
                        (onSelect)="onWarehouseSelect($event, field)"
                        [ngStyle]="getCustomStyles(field)"
                      >
                        <ng-template let-warehouse pTemplate="item">
                          {{ warehouse.label }}
                        </ng-template>
                      </p-autocomplete>
                    }
                    @case ("couponAutocomplete") {
                      <!-- Custom coupon autocomplete (chips rendered separately as full-width below the section) -->
                      <div class="coupon-autocomplete-wrapper">
                        <p-autocomplete
                          [formControlName]="field.controlName"
                          [attr.required]="field.required ? '' : null"
                          [suggestions]="
                            couponSuggestions[field.controlName] || []
                          "
                          [minLength]="1"
                          [showClear]="false"
                          [dropdown]="false"
                          [forceSelection]="false"
                          [disabled]="
                            field.disabled || viewMode || isFieldDisabled(field)
                          "
                          [readonly]="field.readonly || viewMode"
                          [multiple]="true"
                          [optionLabel]="'couponCode'"
                          [placeholder]="
                            !viewMode &&
                            !isFieldDisabled(field) &&
                            !field.disabled
                              ? getFieldPlaceholder(field)
                              : ''
                          "
                          [class]="
                            'w-full text-sm coupon-autocomplete-field ' +
                            (shouldShowErrorStyling(field.controlName)
                              ? 'show-error-styling'
                              : '')
                          "
                          [ngStyle]="getCustomStyles(field)"
                          (completeMethod)="onCouponSearch($event, field)"
                          (onSelect)="onCouponSelect($event, field)"
                          (onUnselect)="onCouponUnselect($event, field)"
                        >
                          <ng-template let-coupon pTemplate="item">
                            {{ coupon?.couponCode }}
                          </ng-template>
                        </p-autocomplete>
                      </div>
                    }
                    @case ("treeselect") {
                      <p-treeselect
                        [formControlName]="field.controlName"
                        [attr.data-testid]="'form-field-' + field.controlName"
                        [attr.required]="field.required ? '' : null"
                        [options]="field.treeOptions || []"
                        [placeholder]="
                          !viewMode && !isFieldDisabled(field)
                            ? getFieldPlaceholder(field)
                            : ''
                        "
                        optionLabel="label"
                        optionValue="value"
                        [selectionMode]="
                          field.useCheckbox === false ? 'single' : 'checkbox'
                        "
                        [metaKeySelection]="false"
                        [propagateSelectionUp]="false"
                        [propagateSelectionDown]="false"
                        [filter]="false"
                        [class]="
                          'w-full text-sm ' +
                          (shouldShowErrorStyling(field.controlName)
                            ? 'show-error-styling'
                            : '')
                        "
                        (onChange)="onDropdownChange(field.controlName, $event)"
                        [ngStyle]="getCustomStyles(field)"
                      ></p-treeselect>
                    }
                    @case ("textarea") {
                      @if (viewMode && textOnlyMode) {
                        <div
                          class="w-full text-sm py-2 whitespace-pre-wrap"
                          [ngStyle]="getCustomStyles(field)"
                        >
                          {{ form.get(field.controlName)?.value || "-" }}
                        </div>
                      } @else {
                        <textarea
                          pTextarea
                          [formControlName]="field.controlName"
                          [attr.data-testid]="'form-field-' + field.controlName"
                          [placeholder]="
                            !viewMode && !isFieldDisabled(field)
                              ? getFieldPlaceholder(field)
                              : ''
                          "
                          [attr.required]="field.required ? '' : null"
                          rows="3"
                          class="w-full text-sm"
                          [ngStyle]="getCustomStyles(field)"
                        ></textarea>
                      }
                    }
                    @case ("html-description") {
                      <app-html-description
                        [attr.data-testid]="'form-field-' + field.controlName"
                        [formControlName]="field.controlName"
                        [config]="getHtmlDescriptionConfig(field)"
                      ></app-html-description>
                    }
                    @case ("radio") {
                      <div class="flex gap-2">
                        <div class="flex gap-4 h-full">
                          @for (
                            option of getFieldOptions(field);
                            track option.label
                          ) {
                            <div class="flex items-center">
                              <p-radiobutton
                                [attr.data-testid]="
                                  'form-field-' +
                                  field.controlName +
                                  '-option-' +
                                  normalizeTestIdSegment(option.label)
                                "
                                [name]="field.controlName"
                                [inputId]="
                                  field.controlName + '_' + option.label
                                "
                                [formControlName]="field.controlName"
                                [value]="option.value"
                                [attr.required]="field.required ? '' : null"
                                size="small"
                                (onClick)="
                                  onRadioChange(field.controlName, option.value)
                                "
                              ></p-radiobutton>
                              <label
                                class="ml-2 text-sm"
                                [for]="field.controlName + '_' + option.label"
                              >
                                {{ option.label | translate }}
                              </label>
                            </div>
                          }
                        </div>
                        @if (selectedRadioValues[field.controlName] === true) {
                          @if (field.controlName === "includesShippingFee") {
                            <p-inputNumber
                              [attr.data-testid]="
                                'form-field-' +
                                field.controlName +
                                '-shipping-fee'
                              "
                              [placeholder]="
                                'common.form.placeholders.enter_shipping_fee'
                                  | translate
                              "
                              [ngModelOptions]="{ standalone: true }"
                              [(ngModel)]="additionalValues[field.controlName]"
                              [disabled]="viewMode"
                              class="w-full text-sm ml-4"
                            ></p-inputNumber>
                          }
                        }
                      </div>

                      @if (selectedRadioValues[field.controlName] === true) {
                        @if (field.controlName === "hasThirdPartyDiscount") {
                          <div class="flex flex-col mt-2">
                            <div class="flex gap-4">
                              <p-inputNumber
                                [attr.data-testid]="
                                  'form-field-' +
                                  field.controlName +
                                  '-third-party-discount'
                                "
                                [placeholder]="
                                  'common.form.placeholders.enter_third_party_discount'
                                    | translate
                                "
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="
                                  additionalValues[field.controlName]
                                "
                                [disabled]="viewMode"
                                class="w-full text-sm"
                              ></p-inputNumber>
                              <p-inputNumber
                                data-testid="form-field-platform-discount"
                                [placeholder]="
                                  'common.form.placeholders.platform_bears_discount'
                                    | translate
                                "
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="
                                  additionalValues['platformDiscount']
                                "
                                [disabled]="viewMode"
                                class="w-full text-sm"
                              ></p-inputNumber>
                              <p-inputNumber
                                data-testid="form-field-merchant-discount"
                                [placeholder]="
                                  'common.form.placeholders.merchant_bears_discount'
                                    | translate
                                "
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="
                                  additionalValues['merchantDiscount']
                                "
                                [disabled]="viewMode"
                                class="w-full text-sm"
                              ></p-inputNumber>
                            </div>
                          </div>
                        }
                      }
                    }
                    @case ("checkbox") {
                      <div
                        class="flex items-center"
                        [class.checkbox-disabled]="isFieldDisabled(field)"
                      >
                        <span
                          class="mr-3 text-sm font-medium text-gray-700"
                          [class.label-disabled]="isFieldDisabled(field)"
                        >
                          {{ getFieldPlaceholder(field) }}
                        </span>
                        <p-checkbox
                          [formControlName]="field.controlName"
                          [attr.data-testid]="'form-field-' + field.controlName"
                          [attr.required]="field.required ? '' : null"
                          [binary]="true"
                          [disabled]="isFieldDisabled(field)"
                          (onChange)="
                            onCheckboxChange(field.controlName, $event)
                          "
                        ></p-checkbox>
                      </div>
                    }
                    @case ("file") {
                      @if (getMaxFilesForField(field.controlName) > 1) {
                        <!-- Multi-file upload -->
                        <div class="multi-file-upload-container">
                          <app-multi-file-upload
                            [attr.data-testid]="
                              'form-field-' + field.controlName
                            "
                            [placeholder]="
                              getUploadPlaceholder(field, uploadConfig)
                            "
                            [accept]="field.accept || 'image/*'"
                            [maxSize]="field.maxSize || 5 * 1024 * 1024"
                            [acceptedTypes]="
                              getAcceptedTypesText(field, uploadConfig)
                            "
                            [maxFiles]="getMaxFilesForField(field.controlName)"
                            [disabled]="viewMode"
                            [editMode]="editMode"
                            [uploadConfig]="uploadConfig"
                            [existingFiles]="
                              getExistingFiles(field.controlName)
                            "
                            (filesChanged)="
                              onMultiFileUpload($event, field.controlName)
                            "
                            (filesRemoved)="
                              onMultiFileRemoved($event, field.controlName)
                            "
                          ></app-multi-file-upload>
                        </div>
                      } @else {
                        <!-- Single file upload -->
                        <div
                          class="single-file-upload"
                          [class.multi-file-detail-images]="
                            field.controlName === 'mainImage' &&
                            hasMultipleDetailImages()
                          "
                        >
                          <app-file-upload
                            [attr.data-testid]="
                              'form-field-' + field.controlName
                            "
                            [formControlName]="field.controlName"
                            [placeholder]="
                              getUploadPlaceholder(field, uploadConfig)
                            "
                            [accept]="field.accept || 'image/*'"
                            [maxSize]="field.maxSize || 5 * 1024 * 1024"
                            [acceptedTypes]="
                              getAcceptedTypesText(field, uploadConfig)
                            "
                            [multiple]="field.multiple || false"
                            [disabled]="viewMode"
                            [editMode]="editMode"
                            [videoMinDurationSec]="field.videoMinDurationSec"
                            [videoMaxDurationSec]="field.videoMaxDurationSec"
                            [videoMaxWidthPx]="field.videoMaxWidthPx"
                            [videoMaxHeightPx]="field.videoMaxHeightPx"
                            (fileChange)="
                              onFileUpload($event, field.controlName)
                            "
                            (imageRemoved)="
                              onImageRemoved(field.controlName, $event)
                            "
                          ></app-file-upload>
                        </div>
                      }
                    }
                    @case ("multi-file") {
                      <!-- Multi-file upload for detail images -->
                      <div class="multi-file-upload-container">
                        <app-multi-file-upload
                          [attr.data-testid]="'form-field-' + field.controlName"
                          #multiFileUpload
                          [fieldName]="field.controlName"
                          [placeholder]="
                            getUploadPlaceholder(field, uploadConfig)
                          "
                          [accept]="field.accept || 'image/*'"
                          [maxSize]="field.maxSize || 5 * 1024 * 1024"
                          [acceptedTypes]="
                            getAcceptedTypesText(field, uploadConfig)
                          "
                          [maxFiles]="getMaxFilesForField(field.controlName)"
                          [disabled]="viewMode"
                          [editMode]="editMode"
                          [uploadConfig]="uploadConfig"
                          [existingFiles]="getExistingFiles(field.controlName)"
                          [reorderable]="field.reorderable === true"
                          (filesChanged)="
                            onMultiFileUpload($event, field.controlName)
                          "
                          (filesRemoved)="
                            onMultiFileRemoved($event, field.controlName)
                          "
                          (existingImagesReordered)="
                            onExistingImagesReordered($event, field.controlName)
                          "
                        ></app-multi-file-upload>
                      </div>
                    }
                    @case ("image-display") {
                      <div class="image-display-container">
                        @if (getImagePreview(field.controlName); as imageData) {
                          <div
                            class="image-preview {{
                              field.controlName === 'mainImage' &&
                              hasMultipleDetailImages()
                                ? 'h-[160px]'
                                : 'h-[135px]'
                            }}"
                          >
                            <img
                              [src]="imageData.previewUrl"
                              [alt]="field.label | translate"
                              class="upload-area-image"
                            />
                            <div class="image-info">
                              <div class="image-name">
                                {{
                                  imageData.fileName ||
                                    ("common.form.placeholders.image_from_material"
                                      | translate)
                                }}
                              </div>
                              @if (imageData.fileSize) {
                                <div class="image-size">
                                  {{ formatFileSize(imageData.fileSize) }}
                                </div>
                              }
                            </div>
                          </div>
                        } @else {
                          <div class="upload-area">
                            <div class="upload-content">
                              <div class="upload-text">
                                {{
                                  field.placeholder ||
                                    ("common.form.placeholders.no_image_available"
                                      | translate)
                                }}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @case ("galleria-display") {
                      @if (
                        field.controlName === "detailedImage"
                          ? getDetailedImages()
                          : field.controlName === "mainImage"
                            ? getMainImages()
                            : getConditionalImages(field.controlName);
                        as images
                      ) {
                        @if (images.length === 1) {
                          <div class="image-display-container">
                            <div
                              class="image-preview {{
                                images[0].isVideo
                                  ? 'h-[240px]'
                                  : field.controlName === 'mainImage' &&
                                      hasMultipleDetailImages()
                                    ? 'h-[160px]'
                                    : 'h-[135px]'
                              }}"
                            >
                              @if (
                                images[0].isVideo &&
                                images[0].videoType === "EXTERNAL_LINK"
                              ) {
                                @if (
                                  getVideoEmbedUrl(
                                    images[0].videoUrl || images[0].src,
                                    images[0].videoExternalPlatform
                                  );
                                  as embedUrl
                                ) {
                                  <iframe
                                    [src]="embedUrl"
                                    class="upload-area-video"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                  ></iframe>
                                } @else {
                                  <a
                                    [href]="images[0].videoUrl || images[0].src"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >{{ images[0].videoUrl || images[0].src }}</a
                                  >
                                }
                              } @else if (images[0].isVideo) {
                                <video
                                  [src]="images[0].videoUrl || images[0].src"
                                  controls
                                  class="upload-area-video"
                                ></video>
                              } @else {
                                <img
                                  [src]="images[0].src"
                                  [alt]="field.label | translate"
                                  class="upload-area-image"
                                />
                              }
                              <div class="image-info">
                                <div class="image-name">
                                  {{ images[0].title || images[0].alt }}
                                </div>
                                @if (images[0].fileSize) {
                                  <div class="image-size">
                                    {{ formatFileSize(images[0].fileSize) }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        } @else if (images.length > 1) {
                          <app-galleria
                            [attr.data-testid]="
                              'form-field-' + field.controlName
                            "
                            [images]="images"
                            [config]="getGalleriaConfig(field)"
                            [disabled]="viewMode"
                            [loading]="false"
                            emptyMessage="No images available"
                          ></app-galleria>
                        } @else {
                          <div class="image-display-container">
                            <div
                              class="image-preview {{
                                field.controlName === 'mainImage' &&
                                hasMultipleDetailImages()
                                  ? 'h-[160px]'
                                  : 'h-[135px]'
                              }}"
                            >
                              <div class="upload-content">
                                <div class="upload-text">
                                  {{
                                    field.placeholder | translate
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      } @else {
                        <div class="image-display-container">
                          <div
                            class="image-preview {{
                              field.controlName === 'mainImage' &&
                              hasMultipleDetailImages()
                                ? 'h-[160px]'
                                : 'h-[135px]'
                            }}"
                          >
                            <div class="upload-content">
                              <div class="upload-text">
                                {{
                                  "goods.spu.form.placeholders.image_from_product_asset"
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    }
                  }
                  <!-- âœ… close @switch -->
                  @if (
                    shouldShowError(field.controlName) &&
                    field.type !== "number"
                  ) {
                    <div class="validation-error text-sm">
                      {{ getErrorMessage(field) | translate: getErrorParams(field) }}
                    </div>
                  }
                  @if (getFieldHint(field) && !field.hintAsTooltip) {
                    <small
                      class="field-hint block text-xs text-amber-600 mt-1"
                      [attr.data-testid]="'form-field-hint-' + field.controlName"
                    >
                      <i class="pi pi-info-circle text-xs"></i>
                      {{ getFieldHint(field) }}
                    </small>
                  }
                  @for (
                    nestedField of getNestedFields(section, field.controlName);
                    track nestedField.controlName
                  ) {
                    @if (!nestedField.hidden) {
                      <div
                        class="form-field-nested mt-2"
                        [attr.data-testid]="
                          'form-field-' + nestedField.controlName + '-wrapper'
                        "
                      >
                        @if (!nestedField.hideLabel) {
                          <div class="form-label text-sm">
                            <span class="label-text-wrapper inline-flex items-center">
                              @if (nestedField.translateLabel !== false) {
                                {{ getFieldLabel(nestedField) | translate }}
                              } @else {
                                {{ getFieldLabel(nestedField) }}
                              }
                              @if (nestedField.required) {
                                <span class="text-red-500">*</span>
                              }
                              @if (nestedField.hint && nestedField.hintAsTooltip) {
                                <span
                                  class="material-symbols-outlined ml-1 text-gray-400 hover:text-blue-500 cursor-help text-xs"
                                  [pTooltip]="getFieldHint(nestedField)"
                                  tooltipPosition="top"
                                  >info</span
                                >
                              }
                            </span>
                          </div>
                        }
                        @switch (nestedField.type) {
                          @case ("dropdown") {
                            <p-select
                              [formControlName]="nestedField.controlName"
                              [attr.data-testid]="'form-field-' + nestedField.controlName"
                              [attr.required]="nestedField.required ? '' : null"
                              [options]="getFieldOptions(nestedField)"
                              [placeholder]="
                                !viewMode && !isFieldDisabled(nestedField)
                                  ? getFieldPlaceholder(nestedField)
                                  : ''
                              "
                              optionLabel="label"
                              optionValue="value"
                              [class]="
                                'w-full text-sm ' +
                                (shouldShowErrorStyling(nestedField.controlName)
                                  ? 'show-error-styling'
                                  : '') +
                                (isFieldDisabled(nestedField)
                                  ? ' dropdown-disabled'
                                  : '')
                              "
                              (onChange)="
                                onDropdownChange(nestedField.controlName, $event)
                              "
                              [showClear]="getShowClearForField(nestedField)"
                            ></p-select>
                          }
                          @case ("file") {
                            <div class="single-file-upload">
                              <app-file-upload
                                [attr.data-testid]="
                                  'form-field-' + nestedField.controlName
                                "
                                [formControlName]="nestedField.controlName"
                                [placeholder]="
                                  getUploadPlaceholder(nestedField, uploadConfig)
                                "
                                [accept]="nestedField.accept || 'image/*'"
                                [maxSize]="nestedField.maxSize || 5 * 1024 * 1024"
                                [acceptedTypes]="
                                  getAcceptedTypesText(nestedField, uploadConfig)
                                "
                                [multiple]="nestedField.multiple || false"
                                [disabled]="viewMode"
                                [editMode]="editMode"
                                [videoMinDurationSec]="nestedField.videoMinDurationSec"
                                [videoMaxDurationSec]="nestedField.videoMaxDurationSec"
                                [videoMaxWidthPx]="nestedField.videoMaxWidthPx"
                                [videoMaxHeightPx]="nestedField.videoMaxHeightPx"
                                (fileChange)="
                                  onFileUpload($event, nestedField.controlName)
                                "
                                (imageRemoved)="
                                  onImageRemoved(nestedField.controlName, $event)
                                "
                              ></app-file-upload>
                            </div>
                          }
                          @case ("text") {
                            <div class="relative w-full">
                              <input
                                pInputText
                                [formControlName]="nestedField.controlName"
                                [attr.data-testid]="
                                  'form-field-' + nestedField.controlName
                                "
                                [attr.value]="
                                  form.get(nestedField.controlName)?.value ?? null
                                "
                                [placeholder]="
                                  !viewMode && !isFieldDisabled(nestedField)
                                    ? getFieldPlaceholder(nestedField)
                                    : ''
                                "
                                [readonly]="nestedField.readonly || viewMode"
                                [attr.required]="nestedField.required ? '' : null"
                                class="w-full text-sm pr-8"
                                (input)="
                                  onTextInputChange(nestedField.controlName, $event)
                                "
                                (compositionstart)="
                                  onCompositionStart(nestedField.controlName)
                                "
                                (compositionend)="
                                  onCompositionEnd(nestedField.controlName, $event)
                                "
                                (blur)="onTextBlur(nestedField.controlName, $event)"
                              />
                              @if (
                                nestedField.showVideoPlatformHint &&
                                getVideoPlatformIconClass(nestedField);
                                as icon
                              ) {
                                <i
                                  [class]="
                                    'pi ' +
                                    icon +
                                    ' absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-sm'
                                  "
                                ></i>
                              }
                            </div>
                          }
                        }
                        @if (shouldShowError(nestedField.controlName)) {
                          <div class="validation-error text-sm">
                            {{ getErrorMessage(nestedField) | translate: getErrorParams(nestedField) }}
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>
          @if (
            showScopeLinesInPeriodicSection &&
            (section === "offer.form.sections.periodic_discount" ||
              section === "Periodic Discount Configuration" ||
              section === "offer.form.sections.configuration")
          ) {
            <div class="px-4 pb-2">
              <div class="mb-3">
                <h3 class="text-sm font-semibold text-gray-700">Scope Lines</h3>
                <div class="mt-2">
                  <p-button
                    data-testid="add-form-scope-line-add-btn"
                    label="New"
                    icon="add"
                    severity="info"
                    size="small"
                    styleClass="scope-new-button"
                    (onClick)="onScopeLineAdd()"
                  />
                </div>
              </div>

              <div class="flex flex-col gap-2">
                @for (row of scopeLines; track row.id) {
                  <div class="grid grid-cols-12 gap-2 items-center">
                    <div class="col-span-4">
                      <p-select
                        [attr.data-testid]="
                          'add-form-scope-line-type-select-' +
                          normalizeTestIdSegment(row.id)
                        "
                        [options]="scopeTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        [ngModel]="row.scopeType"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onScopeLineTypeChange(row.id, $event)"
                        placeholder="Select scope type"
                        appendTo="body"
                        styleClass="w-full scope-lines-scope-select"
                        panelStyleClass="scope-lines-select-panel"
                      />
                    </div>

                    <div class="col-span-7">
                      <input
                        [attr.data-testid]="
                          'add-form-scope-line-value-input-' +
                          normalizeTestIdSegment(row.id)
                        "
                        pInputText
                        class="w-full"
                        [attr.value]="row.scopeValue"
                        [ngModel]="row.scopeValue"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onScopeLineValueChange(row.id, $event)"
                        placeholder="Enter scope value"
                      />
                    </div>

                    <div class="col-span-1 flex justify-end">
                      <p-button
                        [attr.data-testid]="
                          'add-form-scope-line-delete-btn-' +
                          normalizeTestIdSegment(row.id)
                        "
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        [rounded]="true"
                        (onClick)="onScopeLineDelete(row.id)"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (
            showScopeLinesInMixMatchSection &&
            (section === "offer.form.sections.mix_match" ||
              section === "Mix & Match Configuration" ||
              section === "offer.form.sections.configuration")
          ) {
            <div class="px-4 pb-2">
              <div class="mb-3">
                <h3 class="text-sm font-semibold text-gray-700">Scope Lines</h3>
                <div class="mt-2">
                  <p-button
                    data-testid="add-form-mix-match-scope-line-add-btn"
                    label="New"
                    icon="add"
                    severity="info"
                    size="small"
                    styleClass="scope-new-button"
                    (onClick)="onMixMatchScopeLineAdd()"
                  />
                </div>
              </div>

              <div class="flex flex-col gap-2">
                @for (row of mixMatchScopeLines; track row.id) {
                  <div class="grid grid-cols-12 gap-2 items-center">
                    <div class="col-span-4">
                      <p-select
                        [attr.data-testid]="
                          'add-form-mix-match-scope-line-type-select-' +
                          normalizeTestIdSegment(row.id)
                        "
                        [options]="mixMatchScopeTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        [ngModel]="row.scopeType"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="
                          onMixMatchScopeLineTypeChange(row.id, $event)
                        "
                        placeholder="Select scope type"
                        appendTo="body"
                        styleClass="w-full scope-lines-scope-select"
                        panelStyleClass="scope-lines-select-panel"
                      />
                    </div>

                    <div class="col-span-7">
                      <input
                        [attr.data-testid]="
                          'add-form-mix-match-scope-line-value-input-' +
                          normalizeTestIdSegment(row.id)
                        "
                        pInputText
                        class="w-full"
                        [attr.value]="row.scopeValue"
                        [ngModel]="row.scopeValue"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="
                          onMixMatchScopeLineValueChange(row.id, $event)
                        "
                        placeholder="Enter scope value"
                      />
                    </div>

                    <div class="col-span-1 flex justify-end">
                      <p-button
                        [attr.data-testid]="
                          'add-form-mix-match-scope-line-delete-btn-' +
                          normalizeTestIdSegment(row.id)
                        "
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        [rounded]="true"
                        (onClick)="onMixMatchScopeLineDelete(row.id)"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (
            showMultibuyTiersInSection &&
            (section === "offer.form.sections.multibuy" ||
              section === "Multibuy Configuration" ||
              section === "offer.form.sections.configuration")
          ) {
            <div class="px-4 pb-2">
              <div class="mb-3">
                <h3 class="text-sm font-semibold text-gray-700">
                  Tiers (Buy X Get Y)
                </h3>
                <div class="mt-2">
                  <p-button
                    data-testid="add-form-multibuy-tier-add-btn"
                    label="New"
                    icon="add"
                    severity="info"
                    size="small"
                    styleClass="scope-new-button"
                    (onClick)="onMultibuyTierAdd()"
                  />
                </div>
              </div>

              <div class="flex flex-col gap-2">
                @for (row of multibuyTiers; track row.id) {
                  <div class="flex flex-wrap items-center gap-3 w-full">
                    <div class="flex items-center gap-2">
                      <span
                        class="text-sm font-medium text-gray-700 whitespace-nowrap shrink-0"
                      >
                        Buy
                      </span>
                      <div class="w-20 shrink-0 multibuy-tier-input-wrap">
                        <p-inputNumber
                          [attr.data-testid]="
                            'add-form-multibuy-tier-buy-qty-input-' +
                            normalizeTestIdSegment(row.id)
                          "
                          placeholder="Qty"
                          [ngModel]="row.buyQty"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="
                            onMultibuyTierBuyQtyChange(row.id, $event)
                          "
                          [min]="0"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <span
                        class="text-sm font-medium text-gray-700 whitespace-nowrap shrink-0"
                      >
                        Get
                      </span>
                      <div class="w-20 shrink-0 multibuy-tier-input-wrap">
                        <p-inputNumber
                          [attr.data-testid]="
                            'add-form-multibuy-tier-get-qty-input-' +
                            normalizeTestIdSegment(row.id)
                          "
                          placeholder="Qty"
                          [ngModel]="row.getQty"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="
                            onMultibuyTierGetQtyChange(row.id, $event)
                          "
                          [min]="0"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <span
                        class="text-sm font-medium text-gray-700 whitespace-nowrap shrink-0"
                      >
                        At
                      </span>
                      <div class="w-20 shrink-0 multibuy-tier-input-wrap">
                        <p-inputNumber
                          [attr.data-testid]="
                            'add-form-multibuy-tier-at-percent-input-' +
                            normalizeTestIdSegment(row.id)
                          "
                          placeholder="%"
                          [ngModel]="row.atPercent"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="
                            onMultibuyTierAtPercentChange(row.id, $event)
                          "
                          [min]="0"
                          [max]="100"
                          class="w-full"
                        />
                      </div>
                    </div>
                    <div class="flex shrink-0 justify-end">
                      <p-button
                        [attr.data-testid]="
                          'add-form-multibuy-tier-delete-btn-' +
                          normalizeTestIdSegment(row.id)
                        "
                        icon="pi pi-trash"
                        severity="danger"
                        [text]="true"
                        [rounded]="true"
                        (onClick)="onMultibuyTierDelete(row.id)"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (
            configurationAppendTemplate &&
            section === configurationAppendSectionKey
          ) {
            <div class="px-4 pb-2 offer-configuration-append">
              <ng-container
                [ngTemplateOutlet]="configurationAppendTemplate"
              ></ng-container>
            </div>
          }
        </section>
        @for (ts of getTableSectionsAfter(section); track ts.title) {
          <ng-container
            *ngTemplateOutlet="tableSectionBlock; context: { $implicit: ts }"
          ></ng-container>
        }
      }

      <!-- Dynamic Table Sections: only sections without insertAfterSection (e.g. product_list). Sections with insertAfterSection (e.g. product/order field mapping) are rendered via getTableSectionsAfter() + tableSectionBlock above. -->
      @if (getTableSectionsAtEnd().length > 0) {
        @for (
          tableSection of getTableSectionsAtEnd();
          track tableSection.title
        ) {
          @if (tableSection.show) {
            <div
              class="form-product"
              [attr.data-section]="tableSection.name || 'table-section'"
            >
              <h2 class="section-title text-sm">
                {{ tableSection.title | translate }}
              </h2>

              <!-- Error Message -->
              @if (tableSection.errorMessage) {
                <div class="validation-error text-sm px-2 pt-2">
                  {{ tableSection.errorMessage | translate }}
                </div>
              }

              <!-- Search Form (if configured) -->
              @if (
                tableSection.searchFormConfig &&
                tableSection.searchFormConfig.length > 0
              ) {
                <div class="px-2 pt-2">
                  <app-search-form
                    [attr.data-testid]="
                      getTableSectionTestId(tableSection, 'search-form')
                    "
                    [searchFormat]="tableSection.searchFormConfig"
                    (formSearch)="tableSection.onSearch?.($event)"
                    (formReset)="tableSection.onReset?.()"
                  >
                    <div slot="actions" class="flex gap-2">
                      @if (
                        tableSection.useAdvancedTable &&
                        tableSection.flexibleColumns &&
                        tableSection.flexibleColumns.length > 0
                      ) {
                        <app-button
                          [testId]="
                            getTableSectionTestId(
                              tableSection,
                              'column-config-btn'
                            )
                          "
                          type="success"
                          [outlined]="true"
                          icon="view_column"
                          (emitOnClick)="
                            handleColumnConfigClick(tableSection, $event)
                          "
                        ></app-button>
                      }
                      @if (
                        tableSection.primaryButton &&
                        tableSection.primaryButton.show !== false
                      ) {
                        <app-status-filter
                          [attr.data-testid]="
                            getTableSectionTestId(
                              tableSection,
                              'status-filter'
                            )
                          "
                          [primaryButton]="tableSection.primaryButton"
                          (primaryButtonClick)="
                            handleprimaryButtonClick(tableSection)
                          "
                        ></app-status-filter>
                      }
                    </div>
                  </app-search-form>
                </div>
              }

              <!-- Table Actions -->
              @if (
                tableSection.actions &&
                tableSection.actions.length > 0 &&
                !viewMode
              ) {
                <div class="flex gap-2 px-2 pt-2">
                  @for (action of tableSection.actions; track action.action) {
                    <app-button
                      [testId]="
                        getTableSectionTestId(
                          tableSection,
                          'action-' + action.action
                        )
                      "
                      [label]="action.label"
                      [icon]="action.icon"
                      (emitOnClick)="
                        onTableAction(
                          tableSection.title,
                          action.action,
                          action.action === 'deleteSelected'
                            ? tableSection.selection
                            : undefined
                        )
                      "
                      [disabled]="action.disabled || false"
                      [type]="action.severity || 'secondary'"
                      [outlined]="action.outlined || false"
                    ></app-button>
                  }
                </div>
              }

              <!-- Data Table -->
              <div class="px-2 pt-4">
                @if (tableSection.useAdvancedTable) {
                  <advanced-data-table
                    [attr.data-testid]="
                      getTableSectionTestId(tableSection, 'table')
                    "
                    [dataSource]="tableSection.data"
                    [defaultColumns]="
                      tableSection.defaultColumns || tableSection.columns
                    "
                    [flexibleColumns]="tableSection.flexibleColumns || []"
                    [rows]="tableSection.rows || 20"
                    [first]="tableSection.first || 0"
                    [totalRecords]="
                      tableSection.totalRecords || tableSection.data.length
                    "
                    [loading]="tableSection.loading || false"
                    [hasCheckColumn]="tableSection.hasCheckbox || false"
                    [hasSerialColumn]="tableSection.hasSerialColumn !== false"
                    [selection]="tableSection.selection || []"
                    [actionsTemplate]="actionsTemplate"
                    [scrollHeight]="scrollHeight"
                    [showInternalColumnConfigButton]="false"
                    (pageChange)="tableSection.onPageChange?.($event)"
                    (selectionChange)="
                      onTableSelectionChange(tableSection.title, $event)
                    "
                    class="text-sm"
                  >
                    <!-- Custom templates for advanced table -->
                    <ng-template
                      #customTemplate
                      let-value
                      let-rowData="rowData"
                      let-column="column"
                    >
                      @if (tableSection.name === "product_list") {
                        @if (column && column.template === "currencyTemplate") {
                          <span class="text-xs text-gray-600 text-right">
                            {{ formatCurrency(value) }}
                          </span>
                        }
                      } @else if (
                        tableSection.name === "issued_coupon_information"
                      ) {
                        @if (
                          column?.prop === "creationDate" ||
                          column?.prop === "lastUpdateDate"
                        ) {
                          <span class="text-xs text-gray-600">
                            {{
                              value
                                ? (value | date: "dd/MM/yyyy HH:mm:ss")
                                : ""
                            }}
                          </span>
                        }
                      }
                    </ng-template>

                    <!-- Status Template -->
                    <ng-template #statusTemplate let-status>
                      @if (tableSection.name === "product_list") {
                        <div class="flex items-center justify-center gap-1">
                          <p-tag
                            [attr.data-testid]="
                              getTableSectionTestId(
                                tableSection,
                                'status-tag'
                              )
                            "
                            [value]="getStatusDisplayText(status)"
                            [severity]="getStatusSeverity(status)"
                            styleClass="status-tag"
                            [ngStyle]="getStatusStyle(status)"
                            [pTooltip]="getStatusDisplayText(status)"
                            tooltipPosition="top"
                            tooltipStyleClass="custom-tooltip"
                            [showDelay]="300"
                            [hideDelay]="0"
                          />
                        </div>
                      } @else if (
                        tableSection.name === "issued_coupon_information"
                      ) {
                        <div class="flex items-center justify-center gap-1 w-full">
                          <p-tag
                            [attr.data-testid]="
                              getTableSectionTestId(
                                tableSection,
                                'issued-coupon-status-tag'
                              )
                            "
                            [value]="getIssuedCouponStatusLabel(status)"
                            [severity]="getIssuedCouponStatusSeverity(status)"
                            styleClass="status-tag"
                            [ngStyle]="getIssuedCouponStatusStyle(status)"
                          />
                        </div>
                      }
                    </ng-template>

                    <!-- Actions Template -->
                    <ng-template #actionsTemplate let-rowData>
                      @if (tableSection.name === "product_list") {
                        <div
                          class="flex gap-2 justify-center"
                          [class.pointer-events-none]="
                            tableSection.disableRowActions
                          "
                          [class.opacity-50]="tableSection.disableRowActions"
                        >
                          <!-- Edit -->
                          <button
                            [attr.data-testid]="
                              getTableRowActionTestId(
                                tableSection,
                                rowData,
                                'edit'
                              )
                            "
                            type="button"
                            (click)="
                              onTableAction(tableSection.title, 'edit', rowData)
                            "
                            class="action-link action-edit cursor-pointer"
                          >
                            {{ "common.actions.edit" | translate }}
                          </button>

                          <!-- List for sale: only when DRAFT -->
                          @if (rowData.status === "DRAFT") {
                            <button
                              [attr.data-testid]="
                                getTableRowActionTestId(
                                  tableSection,
                                  rowData,
                                  'activate'
                                )
                              "
                              type="button"
                              (click)="
                                onTableAction(
                                  tableSection.title,
                                  'activate',
                                  rowData
                                )
                              "
                              class="action-link action-enable cursor-pointer"
                            >
                              {{
                                "onlineStore.form.product_list.actions.activate"
                                  | translate
                              }}
                            </button>
                          }

                          <!-- View -->
                          <button
                            [attr.data-testid]="
                              getTableRowActionTestId(
                                tableSection,
                                rowData,
                                'view'
                              )
                            "
                            type="button"
                            (click)="
                              onTableAction(tableSection.title, 'view', rowData)
                            "
                            class="action-link action-view cursor-pointer"
                          >
                            {{ "common.actions.view" | translate }}
                          </button>

                          <!-- Stop selling and delete: when ACTIVE, same action as Delete -->
                          @if (rowData.status === "ACTIVE") {
                            <button
                              [attr.data-testid]="
                                getTableRowActionTestId(
                                  tableSection,
                                  rowData,
                                  'deactivate-delete'
                                )
                              "
                              type="button"
                              (click)="
                                onTableAction(
                                  tableSection.title,
                                  'delete',
                                  rowData
                                )
                              "
                              class="action-link action-delete cursor-pointer"
                            >
                              {{
                                "onlineStore.form.product_list.actions.deactivate_and_delete"
                                  | translate
                              }}
                            </button>
                          }

                          <!-- Delete: only when DRAFT or INACTIVE -->
                          @if (
                            rowData.status === "DRAFT" ||
                            rowData.status === "INACTIVE"
                          ) {
                            <button
                              [attr.data-testid]="
                                getTableRowActionTestId(
                                  tableSection,
                                  rowData,
                                  'delete'
                                )
                              "
                              type="button"
                              (click)="
                                onTableAction(
                                  tableSection.title,
                                  'delete',
                                  rowData
                                )
                              "
                              class="action-link action-delete cursor-pointer"
                            >
                              {{ "common.actions.delete" | translate }}
                            </button>
                          }
                        </div>
                      }
                    </ng-template>
                  </advanced-data-table>
                } @else {
                  <app-data-table
                    [attr.data-testid]="
                      getTableSectionTestId(tableSection, 'table')
                    "
                    [dataSource]="tableSection.data"
                    [columns]="tableSection.columns"
                    [rows]="tableSection.rows || 20"
                    [first]="tableSection.first || 0"
                    [totalRecords]="
                      tableSection.totalRecords || tableSection.data.length
                    "
                    [loading]="tableSection.loading || false"
                    [hasCheckColumn]="tableSection.hasCheckbox || false"
                    [hasSerialColumn]="tableSection.hasSerialColumn !== false"
                    [selection]="tableSection.selection || []"
                    [actionsTemplate]="actionsTemplate"
                    [scrollHeight]="scrollHeight"
                    [getFieldError]="getFieldError"
                    (selectionChange)="
                      onTableSelectionChange(tableSection.title, $event)
                    "
                    (cellValueChange)="
                      onTableCellValueChange(tableSection.title, $event)
                    "
                    (cellInputChange)="
                      onTableCellInputChange(tableSection.title, $event)
                    "
                    (pageChange)="tableSection.onPageChange?.($event)"
                    class="text-sm"
                  >
                    <!-- Pass custom templates to data table -->
                    <ng-template
                      #customTemplate
                      let-rowData
                      let-column="column"
                    >
                      @if (
                        column?.prop === "propertyAsset" &&
                        rowData &&
                        isArray(rowData) &&
                        rowData.length > 0
                      ) {
                        <div class="flex flex-col gap-1">
                          @for (asset of rowData; track asset.asset) {
                            <div class="flex items-center gap-2">
                              @if (asset.image) {
                                <img
                                  [src]="asset.image"
                                  [alt]="asset.originalName"
                                  class="w-6 h-6 object-cover rounded"
                                  (error)="onImageError($event)"
                                />
                              }
                              <span
                                class="text-xs text-gray-600 truncate"
                                [title]="asset.originalName"
                              >
                                {{ asset.originalName }}
                              </span>
                            </div>
                          }
                        </div>
                      } @else if (column?.prop === "propertyAsset") {
                        <span class="text-gray-400 text-xs"></span>
                      } @else if (
                        column?.prop === "generateSku" ||
                        column?.prop === "giftFlag"
                      ) {
                        <span class="text-xs justify-center items-center flex">
                          {{
                            rowData
                              ? ("common.options.yes" | translate)
                              : ("common.options.no" | translate)
                          }}
                        </span>
                      } @else if (column?.template === "currencyTemplate") {
                        <span
                          class="text-xs text-gray-600 flex items-center justify-end"
                        >
                          {{ formatCurrency(rowData) }}
                        </span>
                      } @else {
                        <span class="text-xs">{{ rowData }}</span>
                      }
                    </ng-template>
                  </app-data-table>
                }
              </div>
            </div>
          }
        }
      }

      <!-- Summary Section -->
      @if (summarySectionSignal() && summarySectionSignal()!.show) {
        <section class="form-section">
          <div class="p-4 rounded-lg max-w-3/4">
            <h3 class="font-semibold mb-4 text-sm">
              {{ summarySectionSignal()!.title | translate }}
            </h3>
            <div
              class="grid gap-4"
              [style.grid-template-columns]="
                'repeat(' + summarySectionSignal()!.items.length + ', 1fr)'
              "
            >
              @for (item of summarySectionSignal()!.items; track item.label) {
                <div class="text-center">
                  <div class="text-sm text-gray-600">
                    {{ item.label | translate }}
                  </div>
                  <div class="font-bold text-red-500 text-sm">
                    {{ formatSummaryValue(item) }}
                  </div>
                </div>
              }
            </div>
          </div>
        </section>
      }

      @if (showSpuFaq) {
        <div class="form-product" data-testid="form-section-spu-faq" data-section="spu_faq">
          <app-spu-faq-editor
            [items]="spuFaqItems"
            [viewMode]="viewMode"
            (itemsChange)="spuFaqItemsChange.emit($event)"
          ></app-spu-faq-editor>
        </div>
      }
    </form>
    <!-- Popup menu "Thêm" – giống menu Tạo kho hàng (cùng styleClass, width, appendTo body) -->
    <p-menu
      data-testid="add-form-add-field-menu"
      #addFieldMenu
      [popup]="true"
      [model]="getAddFieldMenuItems()"
      appendTo="body"
      [baseZIndex]="1100"
      [autoZIndex]="true"
      styleClass="create-warehouse-menu"
      [style]="{ width: '200px' }"
      (onHide)="onAddFieldMenuHide()"
    ></p-menu>
  </div>
</div>


